module.exports = __webpack_public_path__ + "img/emoFlags.b8f9ac36.svg";